import TextEditorAreaDescriptive from 'src/components/common/formFields/textAreaDescriptive/TextEditorAreaDescriptive';
import { componentSizeVariantsEnum } from 'src/constants';
import Label from 'src/components/common/formFields/label/Label';

import './previewField.scss';
import { TPreviewFieldProps } from './previewField.types';

const TextEditorArea = ({ id, label, hasCharacterLimit, validations, required, createProgramStep }: TPreviewFieldProps) => {
  return (
    <div key={id} className="dynamic-field">
      <Label required={required}>{label}</Label>
      <div className="custom-application-form__form__row__fields__field_view">
        {' '}
        <TextEditorAreaDescriptive
          id={id}
          variant={componentSizeVariantsEnum.SMALL}
          placeholder={label}
          disabled
          {...(hasCharacterLimit && { textLengthLimit: validations.maxCharacters })}
          createProgramStep
        />
      </div>
    </div>
  );
};

export default TextEditorArea;
